import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

/**
 * Hook that returns handler for any clickable element that should open link.
 * When clicking the middle mouse button, it opens link in the new tab
 * @param url
 */
export const useButtonNavigateClick = (url: string): React.MouseEventHandler<any> => {
  const navigate = useNavigate()

  return useCallback(
    (event) => {
      if (event.button === 1) {
        window.open(url, '_blank')
        return
      }

      navigate(url)
    },
    [url]
  )
}
